// Remove coefficient 1 only before a standalone variable, never inside a subscript.
export function fixLatexCoefficients(str) {
  if (typeof str !== "string") return str;
  return str.replace(/(?<![_\\])-1([a-zA-Z])/g, "-$1")
    .replace(/(?<![0-9a-zA-Z_\\-])1([a-zA-Z])/g, "$1");
}
